import React, { Component, memo } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner'
import { Checkbox } from '@material-ui/core';

import { alertActions } from '../../modules/alert';
import { utilHelper } from '../../helpers';
import { opbcdtService, firmwareMngService } from '../../services';

class FirmwareMngDerv extends Component {
    constructor(props) {
        super(props);
        const { officeCodes } = this.props;

        this.state = {
            pubType: "derv",
            firmwareID: 0,
            title: "",
            version: "",
            uploadFiles: "",
            originFileName: "",

            startHour: "00",
            startMin: "00",
            dervStartTime: "00:00",
            endHour: "23",
            endMin: "59",
            dervEndTime: "23:59",

            officeCodes: officeCodes ? officeCodes : [],
            checkedOfficeCodes: [],
            checkedAllOfficeCodes: false,
            fileChange: false,
            extCheck: false,
            submitted: false,
            pubStatus: false,
        }

        this.setFirmwareDerv();
    }

    setFirmwareDerv = () => {
        let formData = new FormData();
        formData.append('currentPage', 1);
        formData.append('listCount', 1);
        formData.append('pubType', "derv");
        firmwareMngService.firmwareList(formData)
            .then(response => {
                if (response.status === 200 && response.data && response.data.firmwareList.length > 0) {
                    const firmware = response.data.firmwareList[0];
                    const checkedOfficeCodes = firmware.damdangOffice ? firmware.damdangOffice.split(",") : [];

                    this.setState({
                        firmwareID: firmware.firmwareID ? firmware.firmwareID : 0,
                        title: firmware.title ? firmware.title : "",
                        version: firmware.version ? firmware.version : "",
                        uploadFiles: "",
                        originFileName: firmware.originFileName ? firmware.originFileName : "",
                        startHour: firmware.dervStartTime ? firmware.dervStartTime.split(":")[0] : "00",
                        startMin: firmware.dervStartTime ? firmware.dervStartTime.split(":")[1] : "00",
                        dervStartTime: firmware.dervStartTime ? firmware.dervStartTime : "00:00",
                        endHour: firmware.dervEndTime ? firmware.dervEndTime.split(":")[0] : "23",
                        endMin: firmware.dervEndTime ? firmware.dervEndTime.split(":")[1] : "59",
                        dervEndTime: firmware.dervEndTime ? firmware.dervEndTime : "23:59",

                        checkedOfficeCodes: checkedOfficeCodes,
                        checkedAllOfficeCodes: checkedOfficeCodes.length === this.props.officeCodes.length,
                        fileChange: false,
                        extCheck: false,
                        submitted: false,
                        pubStatus: false,
                    });
                }
            })
            .catch(this.handleErrors);
    }


    handleValueChange = (e) => {
        if (e.target.name === "title" && e.target.value.length > 100) {
            // title 100자 체크
            this.props.errorAlerts("경고 100자 초과");
        }
        else if (e.target.name === "version" && e.target.value.length > 20) {
            // version 20자 체크
            this.props.errorAlerts("경고 20자 초과");
        }
        else if (e.target.name === "version" && !(utilHelper.isNumber(e.target.value) || e.target.value === "")) {
            // version 숫자 체크
            this.props.errorAlerts("숫자만 입력하세요.");
        }
        else if (e.target.name === "startHour" || e.target.name === "startMin") {
            const startHour = e.target.name === "startHour" ? utilHelper.pad(e.target.value, 2) : this.state.startHour;
            const startMin = e.target.name === "startMin" ? utilHelper.pad(e.target.value, 2) : this.state.startMin;
            const dervStartTime = startHour + ":" + startMin;

            if (utilHelper.isNumber(e.target.value)) {
                if ((startHour >= 0 && startHour < 24) && (startMin >= 0 && startMin < 60)) {
                    this.setState({
                        startHour: startHour,
                        startMin: startMin,
                        dervStartTime: dervStartTime
                    });
                }
                else {
                    this.props.errorAlerts("시간 범위를 확인하세요.");
                }
            }
            else {
                this.props.errorAlerts("숫자만 입력하세요.");
            }
        }
        else if (e.target.name === "endHour" || e.target.name === "endMin") {
            const endHour = e.target.name === "endHour" ? utilHelper.pad(e.target.value, 2) : this.state.endHour;
            const endMin = e.target.name === "endMin" ? utilHelper.pad(e.target.value, 2) : this.state.endMin;
            const dervEndTime = endHour + ":" + endMin;

            if (utilHelper.isNumber(e.target.value)) {
                if ((endHour >= 0 && endHour < 24) && (endMin >= 0 && endMin < 60)) {
                    this.setState({
                        endHour: endHour,
                        endMin: endMin,
                        dervEndTime: dervEndTime
                    });
                }
                else {
                    this.props.errorAlerts("시간 범위를 확인하세요.");
                }
            }
            else {
                this.props.errorAlerts("숫자만 입력하세요.");
            }
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    };

    handleFileChange = (e) => {
        this.setState({
            fileChange: true,
            extCheck: false,
            [e.target.name]: e.target.files[0] ? e.target.files[0] : this.state.uploadFiles,
        }, () => { this.handleExtCheck(); });
    };

    // 소속 전체/개별 선택
    handleAllChangeCheck = () => {
        const { officeCodes, checkedAllOfficeCodes } = this.state;
        this.setState({
            checkedOfficeCodes: !checkedAllOfficeCodes ? officeCodes.map(code => code.code) : [],
            checkedAllOfficeCodes: !checkedAllOfficeCodes
        });
    };
    handleChangeCheck = (value, checked) => {
        const { checkedOfficeCodes, officeCodes } = this.state;
        this.setState({
            checkedOfficeCodes: checked ? checkedOfficeCodes.concat(value) : checkedOfficeCodes.filter(code => code !== value),
            checkedAllOfficeCodes: checked ? checkedOfficeCodes.concat(value).length === officeCodes.length : false
        });
    };

    // 첨부파일의 확장자 체크
    handleExtCheck = () => {
        let extCheck = false;
        let uploadFilesExt = (this.state.uploadFiles.name.substr(-4).toUpperCase() || "");
        if (uploadFilesExt === ".ZIP") {
            extCheck = true;
            this.setState({
                extCheck: extCheck
            });
        }

        return extCheck;
    };

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    };

    // 저장버튼 클릭
    handlePatchButton = (e) => {
        e.preventDefault();

        this.setState({
            submitted: true
        });

        if (this.validation()) {
            if (this.state.fileChange) {
                this.addFirmware();
            }
            else {
                this.modFirmware();
            }
        }
    };

    validation = () => {
        const { title, version, uploadFiles, originFileName, extCheck, startHour, startMin, endHour, endMin } = this.state;
        if (!title) {
            this.props.errorAlerts("제목은 필수 입력 값입니다.");
            return false;
        } else if (!version) {
            this.props.errorAlerts("버전은 필수 입력 값입니다.");
            return false;
        } else if (!originFileName && !uploadFiles) {
            this.props.errorAlerts("첨부파일은 필수 입력 값입니다.");
        } else if (uploadFiles && !extCheck) {
            this.props.errorAlerts("확장자를 확인하세요.");
            return false;
        } else if (parseInt(startHour + startMin) > parseInt(endHour + endMin)) {
            this.props.errorAlerts("시작시간이 종료시간보다 늦을 수 없습니다.");
            return false;
        } else
            return true;
    };

    addFirmware = () => {
        const { title, version, checkedOfficeCodes, uploadFiles, dervStartTime, dervEndTime } = this.state;
        const damdangOffice = checkedOfficeCodes.length > 0 ? checkedOfficeCodes.join() : "";

        let formData = new FormData();
        formData.append('title', title);
        formData.append('version', version);
        formData.append('allPubType', "damdangOffice");
        formData.append('damdangOrg', "");
        formData.append('damdangOffice', damdangOffice);
        formData.append('pubType', "derv");
        formData.append('target', "firmware");
        formData.append('uploadFiles', uploadFiles);
        formData.append('dervStartTime', dervStartTime);
        formData.append('dervEndTime', dervEndTime);
        formData.append('pubYN', "Y");

        firmwareMngService.addFirmware(formData)
            .then(response => {
                if (response.status === 200) {
                    const firmwareID = response.data.firmwareID;
                    this.patchFirmware(firmwareID);
                }
            })
            .catch(this.handleErrors);
    };

    modFirmware = () => {
        const { firmwareID, title, version, checkedOfficeCodes, dervStartTime, dervEndTime } = this.state;
        const damdangOffice = checkedOfficeCodes.length > 0 ? checkedOfficeCodes.join() : "";

        let formData = new FormData();
        formData.append("firmwareID", firmwareID);
        formData.append('title', title);
        formData.append('version', version);
        formData.append('allPubType', "damdangOffice");
        formData.append('damdangOrg', "");
        formData.append('damdangOffice', damdangOffice);
        formData.append('siteID', 0);
        formData.append('opbNo', 0);
        formData.append('opbID', 0);
        formData.append('pubType', "derv");
        formData.append('target', "firmware");
        formData.append('dervStartTime', dervStartTime);
        formData.append('dervEndTime', dervEndTime);
        formData.append('pubYN', "Y");

        firmwareMngService.modFirmware(formData)
            .then(response => {
                this.patchFirmware(firmwareID);
            })
            .catch(this.handleErrors);
    };

    patchFirmware = (firmwareID) => {
        this.setState({
            pubStatus: true
        });

        let formData = new FormData();
        formData.append("firmwareID", firmwareID);

        opbcdtService.publishPatch(formData)
            .then(response => {
                this.props.successAlerts("배포가 완료되었습니다.");
                this.setFirmwareDerv();
            })
            .catch(error => {
                this.handleErrors(error);
                this.props.errorAlerts("배포 서버 오류 발생! 잠시 후 다시 이용해주세요.");
                this.setFirmwareDerv();
            });
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    render() {
        const { title, version, uploadFiles, originFileName, extCheck, submitted, officeCodes, checkedOfficeCodes, checkedAllOfficeCodes, pubStatus } = this.state;
        return (
            <>
                <h2 className="s-page-tit">예약 패치 관리</h2>
                <div className="search-result-wrapper firmware-mod s-normal-box">
                    {pubStatus
                        ?
                        <div className="text-align-center">
                            <Loader
                                type="Rings"
                                color="#00BFFF"
                                height={'50%'}
                                width={'50%'}
                            />
                        </div>
                        : <>
                            <div className="row">
                                <div className="col col-lg-2 col-3 firmware-mod-title">
                                    <div>제목</div>
                                    <div className="text-color-red">*</div>
                                    <div className="firmware-add-title-length">({title.length}/100)</div>
                                </div>
                                <div className="col col-lg-10 col-9 text-align-left">
                                    <input className="input-box w100per padding-l10" type="text" name="title" value={title} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                                    {submitted && !title &&
                                        <div className="text-color-red">* 제목을 입력하세요.</div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-lg-2 col-3 firmware-mod-title">
                                    <div>버전</div>
                                    <div className="text-color-red">*</div>
                                    <div className="firmware-mod-title-length">({version.length}/20)</div>
                                </div>
                                <div className="col col-lg-10 col-9 text-align-left">
                                    <input className={`input-box w100per padding-l10`} type="text" name="version" value={version} onChange={this.handleValueChange} onKeyPress={this.enterPressed} />
                                    {submitted && !version &&
                                        <div className="text-color-red">* 버전을 입력하세요.</div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-lg-2 col-3 firmware-mod-title">
                                    <div>첨부파일</div>
                                    <div className="text-color-red">*</div>
                                    <div className="firmware-mod-title-length">&nbsp;</div>
                                </div>
                                <div className="col col-lg-10 col-9 text-align-left">
                                    <label className="w100per">
                                        <input className="contents-input-file" type="file" name="uploadFiles" onChange={this.handleFileChange} />
                                        <div className="contents-input-file-name">{(uploadFiles && uploadFiles.name) || originFileName || "ZIP 파일을 업로드해주세요."}</div>
                                        <div className="contents-input-file-button">첨부하기</div>
                                    </label>
                                    {submitted && !originFileName && !uploadFiles &&
                                        <div className="text-color-red">* 첨부파일을 업로드하세요.</div>
                                    }
                                    {submitted && uploadFiles && !extCheck &&
                                        <div className="text-color-red">* 확장자를 확인하세요.</div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-lg-2 col-3 firmware-mod-title">
                                    <div>배포시간</div>
                                    <div className="text-color-red">*</div>
                                    <div className="firmware-mod-title-length">&nbsp;</div>
                                </div>
                                <div className="col col-lg-10 col-9 text-align-left">
                                    <input className={`input-box text-align-center`} style={{ width: "25px" }} name="startHour" value={this.state.startHour} onChange={this.handleValueChange} />시&nbsp;
                                    <input className={`input-box text-align-center`} style={{ width: "25px" }} name="startMin" value={this.state.startMin} onChange={this.handleValueChange} />분&nbsp;
                                    ~&nbsp;&nbsp;
                                    <input className={`input-box text-align-center`} style={{ width: "25px" }} name="endHour" value={this.state.endHour} onChange={this.handleValueChange} />시&nbsp;
                                    <input className={`input-box text-align-center`} style={{ width: "25px" }} name="endMin" value={this.state.endMin} onChange={this.handleValueChange} />분&nbsp;
                            </div>
                            </div>
                            <div className="row">
                                <div className="col col-lg-2 col-3 firmware-mod-title">
                                    <div>소속</div>
                                    <div className="text-color-red">*</div>
                                    <div className="firmware-mod-title-length">&nbsp;</div>
                                </div>
                                <div className="col col-lg-10 col-9">
                                    <table style={{ width: '100%' }}>
                                        <colgroup>
                                            <col width="10%" />
                                            <col width="90%" />
                                        </colgroup>
                                        <thead className={`table-head text-align-center`}>
                                            <tr>
                                                <td><Checkbox color="primary" onChange={this.handleAllChangeCheck} checked={checkedAllOfficeCodes} /></td>
                                                <td>지사명</td>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            {officeCodes &&
                                                officeCodes.map((office, i) => {
                                                    return <FirmwareItemDerv key={i} office={office} ck={checkedOfficeCodes.indexOf(office.code) > -1} handleChangeCheck={this.handleChangeCheck} />;
                                                })
                                            }
                                            {!officeCodes &&
                                                <tr>
                                                    <td>
                                                        <div className="text-align-center">
                                                            <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                                        </div>
                                                    </td>
                                                </tr>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div className="search-button-wrapper text-align-right">
                    <button className="button w100-button margin-r10" onClick={this.handlePatchButton} ref={button => this.buttonAdd = button}>저장</button>
                </div>
            </>
        )
    }
}

const FirmwareItemDerv = memo(
    function FirmwareItemDerv({ office, ck, handleChangeCheck }) {

        return (
            <>
                <tr>
                    <td className="text-align-center"><Checkbox color="primary" onChange={() => { handleChangeCheck(office.code, !ck) }} checked={ck} /></td>
                    <td className="text-align-left">{office.name}</td>
                </tr>
            </>
        );
    }
);


function mapState(state) {
    const { codemng } = state;
    const { codes } = codemng;
    const officeCodes = codes.filter(code => code.groupCode === "DF");

    return { officeCodes };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(FirmwareMngDerv);